<h1 mat-dialog-title class="wf-dialog-title">
  <mat-icon class="wf-title-icon">alt_route</mat-icon>
  <span>{{ data.name }}</span>
</h1>

<div mat-dialog-content class="wf-dialog-content">
  <div class="wf-legend">
    <app-status-category-badge
      *ngFor="let item of legendItems"
      [statusCategory]="item.category"
    ></app-status-category-badge>
    <span class="wf-legend-hint">{{ 'field.diagramHint' | translate }}</span>
  </div>

  <div
    class="wf-canvas"
    [class.panning]="isPanning"
    (pointerdown)="onPanStart($event)"
    (pointermove)="onPanMove($event)"
    (pointerup)="onPanEnd()"
    (pointerleave)="onPanEnd()"
  >
    <div class="wf-stage" [style.transform]="stageTransform">
      <svg [attr.viewBox]="viewBox" [attr.width]="svgWidth" [attr.height]="svgHeight" class="workflow-diagram">
        <defs>
          <marker
            *ngFor="let category of arrowCategories"
            [attr.id]="'wf-arrow-' + category"
            markerWidth="9"
            markerHeight="9"
            refX="7"
            refY="3"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M0,0 L7,3 L0,6 Z" class="wf-arrow-head" [ngClass]="'wf-arrow-' + category" />
          </marker>
        </defs>

        <!-- edges first so nodes render on top -->
        <path
          *ngFor="let edge of edges"
          [attr.d]="edge.path"
          class="wf-edge"
          [ngClass]="'wf-edge-' + edge.category"
          [class.wf-edge-active]="edge.active"
          [class.wf-edge-dim]="edge.dim"
          fill="none"
          [attr.marker-end]="'url(#wf-arrow-' + edge.category + ')'"
        />
        <path
          *ngIf="startEdge"
          [attr.d]="startEdge.path"
          class="wf-edge"
          [ngClass]="'wf-edge-' + startEdge.category"
          [class.wf-edge-active]="startEdge.active"
          [class.wf-edge-dim]="startEdge.dim"
          fill="none"
          [attr.marker-end]="'url(#wf-arrow-' + startEdge.category + ')'"
        />

        <!-- START node -->
        <g class="wf-start" [class.wf-dim]="startDim">
          <text [attr.x]="centerX" [attr.y]="startY - 20" class="wf-start-label" text-anchor="middle">
            {{ 'field.startStep' | translate | uppercase }}
          </text>
          <circle [attr.cx]="centerX" [attr.cy]="startY" r="11" class="wf-start-halo" />
          <circle [attr.cx]="centerX" [attr.cy]="startY" r="7" class="wf-start-node" />
        </g>

        <!-- step nodes -->
        <g
          *ngFor="let node of nodes"
          class="wf-node-group"
          [class.wf-dim]="node.dim"
          (mouseenter)="setHovered(node.id)"
          (mouseleave)="setHovered(null)"
        >
          <rect
            *ngIf="node.isStart"
            [attr.x]="node.x - boxWidth / 2 - 5"
            [attr.y]="node.y - boxHeight / 2 - 5"
            [attr.width]="boxWidth + 10"
            [attr.height]="boxHeight + 10"
            rx="18"
            class="wf-node-ring"
            [ngClass]="'wf-ring-' + node.category"
          />
          <rect
            [attr.x]="node.x - boxWidth / 2"
            [attr.y]="node.y - boxHeight / 2"
            [attr.width]="boxWidth"
            [attr.height]="boxHeight"
            rx="14"
            class="wf-node"
            [ngClass]="'wf-node-' + node.category"
          />
          <rect
            [attr.x]="node.x - boxWidth / 2"
            [attr.y]="node.y - boxHeight / 2"
            [attr.width]="boxWidth"
            [attr.height]="boxHeight"
            rx="14"
            class="wf-state-layer"
            [ngClass]="'wf-state-' + node.category"
          />
          <text
            [attr.x]="node.x - boxWidth / 2 + 18"
            [attr.y]="node.y"
            class="wf-node-icon"
            [ngClass]="'wf-dot-' + node.category"
            text-anchor="middle"
            dominant-baseline="central"
          >
            {{ node.icon }}
          </text>
          <foreignObject
            [attr.x]="node.x - boxWidth / 2 + 32"
            [attr.y]="node.y - boxHeight / 2"
            [attr.width]="boxWidth - 44"
            [attr.height]="boxHeight"
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              class="wf-node-label"
              [ngClass]="'wf-label-' + node.category"
              [title]="node.label"
            >
              {{ node.label }}
            </div>
          </foreignObject>
        </g>
      </svg>
    </div>

    <div class="wf-zoom-bar" (pointerdown)="$event.stopPropagation()">
      <button mat-icon-button type="button" (click)="zoomOut()">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <mat-slider [min]="0.4" [max]="2" [step]="0.1">
        <input matSliderThumb [ngModel]="zoom" (ngModelChange)="setZoom($event)" />
      </mat-slider>
      <button mat-icon-button type="button" (click)="zoomIn()">
        <mat-icon>zoom_in</mat-icon>
      </button>
    </div>
  </div>
</div>

<mat-dialog-actions align="end" class="wf-actions">
  <button matButton="tonal" mat-dialog-close>{{ 'button.close' | translate }}</button>
</mat-dialog-actions>
